export interface ServiceError {
  correlationId: string;
  message: string;
}

export class Config {
  [name: string]: any;
}
